<section class="panel-gallery">
  <form class="panel-gallery__form">
    <!-- Panel Header -->
    <header class="panel-gallery__form__header">
      @if (!ui.editMode) {
        <p class="panel-gallery__form__header__title">{{ panelDef.title }}</p>
      } @else {
        <div class="panel-gallery__form__header__title-edit">
          <mat-form-field>
            <input matInput [formControl]="title" placeholder="Panel title" autocomplete="off" />
          </mat-form-field>
        </div>
      }
      <div class="panel-gallery__form__header__actions">
        @if (!ui.editMode) {
          <button mat-icon-button (click)="fileInput.click()" [disabled]="loading">
            <mat-icon [svgIcon]="'publish'"></mat-icon>
            <input
              #fileInput
              class="hidden"
              [type]="'file'"
              [accept]="allowedFormats.join(',')"
              (change)="onFileSelected($event)"
            />
          </button>
          <button mat-icon-button type="button" [matMenuTriggerFor]="moreMenu">
            <mat-icon class="icon-size-20" svgIcon="more_vert"></mat-icon>
          </button>
        }
        <mat-menu #moreMenu>
          <button mat-menu-item (click)="toggleEditMode()" type="button">
            <mat-icon svgIcon="edit"></mat-icon>
            Edit Layout
          </button>
        </mat-menu>
        @if (ui.editMode) {
          <div class="panel-gallery__form__header__actions__layout">
            <button mat-icon-button type="button" matTooltip="Cancel" (click)="cancelEdit()">
              <mat-icon svgIcon="cancel"></mat-icon>
            </button>
            <button mat-icon-button type="button" matTooltip="Save" (click)="saveLayout()">
              <mat-icon svgIcon="save"></mat-icon>
            </button>
          </div>
        }
      </div>
    </header>

    <!-- Loading State -->
    @if (loading) {
      <mat-progress-bar mode="indeterminate"></mat-progress-bar>
    }

    <!-- Panel Body -->
    <main class="panel-gallery__form__body px-4">
      @if (galleryImages?.length) {
        <section class="flex flex-col">
          <gallery
            gallerize
            #photoGallery
            [items]="galleryImages"
            [dots]="true"
            [thumb]="false"
            [nav]="false"
          ></gallery>
          @if (!ui.editMode) {
            <section class="action-buttons flex justify-between">
              <button mat-icon-button (click)="photoGallery.prev()" [matTooltip]="'Previous photo'">
                <mat-icon [svgIcon]="'chevron_left'"></mat-icon>
              </button>
              <button
                mat-icon-button
                (click)="deletePhoto(photoGallery)"
                [matTooltip]="'Delete active photo'"
                [disabled]="loading"
              >
                <mat-icon [svgIcon]="'delete'"></mat-icon>
              </button>
              <button mat-icon-button (click)="photoGallery.next()" [matTooltip]="'Next photo'">
                <mat-icon [svgIcon]="'chevron_right'"></mat-icon>
              </button>
            </section>
          }
        </section>
      } @else {
        <section class="flex flex-col items-center justify-center h-full">
          <mat-icon class="icon-size-40" [svgIcon]="'image'"></mat-icon>
          <p class="text-2xl text-secondary font-medium mt-4">No images found</p>
          <p class="text-sm text-secondary mt-2">Add images to this panel to display them.</p>
        </section>
      }
    </main>
  </form>
</section>
